// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics } from '@trello/atlassian-analytics';
import { getScreenFromUrl } from '@trello/marketing-screens';

import { l } from 'app/scripts/lib/localize';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';

export function limitErrorPopover({
  trackingArea,
  elem,
  message,
  params,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  const { boardId, orgId } = params;
  Analytics.sendTrackEvent({
    action: 'exceeded',
    actionSubject: trackingArea,
    source: getScreenFromUrl(),
    attributes: {
      message,
    },
    containers: {
      board: {
        id: boardId,
      },
      organization: {
        id: orgId,
      },
    },
  });
  return Confirm.toggle(message, {
    elem,
    html: l(`confirm.${message}.text`, params),
    fxConfirm: () => PopOver.hide(),
  });
}
